import { types as AuthTypes } from 'core/logic/authentication'
import { service } from 'core/modules/firebase'

export const verifyEmail = (data: AuthTypes.CheckingCode) => service.verifyEmail(data)

export const logout = () => service.logout()

export const remove = () => service.remove()
